import React from 'react';
import { Header, ListBox } from '..';
import { Page, ButtonContainer } from './styles';
import { Float } from '../float';
import { useActiveListContext } from '../../context';
import { checkListsExist } from '../../hooks';

export default function ListPage({ setShowTasks, addListRef, addTaskRef }) {
  const { themeColor, themeColor_D2 } = useActiveListContext();
  const { listsExist } = checkListsExist();
  
  return (
    <Page>
      <Header setShowTasks={ setShowTasks}/>

      <ListBox
        setShowTasks={setShowTasks}
        addListRef={addListRef}
        addTaskRef={addTaskRef}
      />

      <ButtonContainer>
        <Float.BotButton
          color={themeColor}
          colorD2={themeColor_D2}
          hasScroll={false}
          forwardedRef={addListRef}
          isHalf='left'
        >
          <span className='button-icon'></span>
          <span className='button-label'>Add List</span>
        </Float.BotButton>
        <Float.BotButton
          disabled={!listsExist}
          color={themeColor}
          colorD2={themeColor_D2}
          hasScroll={false}
          forwardedRef={addTaskRef}
          isHalf='right'
        >
          <span className='button-icon'></span>
          <span className='button-label'>Add Task</span>
        </Float.BotButton>
      </ButtonContainer>
    </Page>
  );
}
